/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 InputLabel, NS/Tractie label-pendant overrides.
// Tractie source: label.
// Tractie label is bold (700) at 0.875rem.
// Floating-label patroon van MUI wordt geneutraliseerd: alle MUI v4 transform-rules
// reset naar 'none' (Tractie heeft geen floating label). Mode-split: Dark spread Light.
//
// MUI v4 InputLabel transforms (bron: @material-ui/core/InputLabel/InputLabel.js):
//   formControl                → translate(0, 24px) scale(1)     reset → none
//   marginDense                → translate(0, 21px) scale(1)     reset → none
//   shrink                     → translate(0, 1.5px) scale(0.75) reset → none
//   outlined                   → translate(14px, 20px) scale(1)  reset → none
//   outlined.&$marginDense     → translate(14px, 12px) scale(1)  reset → none
//   outlined.&$shrink          → translate(14px, -6px) scale(0.75) reset → none
// Diagnose Select dubbele label: zie scratch/494m-diagnose.md (out-of-scope hier).

export const MuiInputLabelLightOverrides = {
  root: {
    color: 'var(--ns-color-fg-emphasis)',
    fontSize: 'var(--ns-font-size-s)',
    fontWeight: 700,
    fontFamily: 'var(--ns-font-family-regular)',
    lineHeight: 1.5,
    transform: 'none',
    transition: 'none',
    position: 'static' as const,
    pointerEvents: 'auto' as const,
    // T1.4 (2026-05-25): pariteit met Tractie total height (92.60). Tractie
    // label-top has natural 2.4px offset from FormControl top; marginTop 2px
    // brings MUI label-top within 0.4px of Tractie's. marginBottom 5px
    // preserves Tractie's label→input gap. Total: 2+21+5+39.6+helper-gap+21
    // ≈ Tractie 92.6 (was 93.6 met marginTop 3).
    marginTop: 2,
    marginBottom: 5,
    '&$focused': {
      color: 'var(--ns-color-fg-emphasis)',
    },
    '&$disabled': {
      color: 'var(--ns-color-fg-emphasis)',
      opacity: 1,
    },
    '&$error': {
      color: 'var(--ns-color-fg-error)',
    },
  },

  shrink: {
    transform: 'none',
    transformOrigin: 'top left',
  },

  animated: {
    transition: 'none',
  },

  formControl: {
    position: 'static' as const,
    transform: 'none',
  },

  marginDense: {
    transform: 'none',
  },
  outlined: {
    transform: 'none',
    '&$marginDense': {
      transform: 'none',
    },
    '&$shrink': {
      transform: 'none',
    },
  },
  filled: {},
  required: {},
  asterisk: {},
  focused: {},
  disabled: {},
  error: {},
} as const;

export const MuiInputLabelDarkOverrides = {
  ...MuiInputLabelLightOverrides,
} as const;
